// Module
var code = "<react-component name=\"BulkMobileAppChanges\"></react-component>\n";
// Exports
module.exports = code;